<template>
  <div>
    <div class="vx-card">
      <div class="vx-card__body">
        <div class="flex">
          <div class="w-full">
            <vs-button
              @click="showFilters = !showFilters"
              class="bg_purple float-right"
              ><div class="px-3">
                <feather-icon
                  icon="FilterIcon"
                  svgClasses="h-4 w-4"
                  class="ico"
                />
                {{ $t("Filter") }}
              </div>
            </vs-button>
          </div>
        </div>
        <form
          class="vx-row px-4 flex flex-col gap-4 justify-end"
          v-if="showFilters"
        >
          <div class="vx-row">
            <!-- <div class="w-full sm:w-1/2 md:w-1/3 lg:w-1/4 px-2">
            <label class="vs-select--label">{{ $t("WarehouseName") }}</label>
            <v-select
              label="name"
              :options="allWarehouses"
              @input="onSelectWarehouse"
              v-model="selectedStore"
              dir="rtl"
            >
            </v-select>
          </div> -->

            <div class="vx-col lg:w-1/2 sm:w-1/1 w-full">
              <label class="vs-select--label mt-1">{{ $t("Product") }}</label>
              <treeselect
                v-model="gridSearchData.StockId"
                name="stockid"
                :multiple="false"
                :placeholder="$t('Search')"
                :async="true"
                :load-options="loadOptions"
                v-validate="'required'"
                @select="onStockSelected"
              />
              <span
                class="text-danger text-sm mt-4"
                v-show="errors.has('stockid')"
                >{{ errors.first("stockid") }}</span
              >
            </div>
            <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
              <label class="vs-select--label datepicker-lb">{{
                $t("FromDate")
              }}</label>

              <date-picker
                v-model="gridSearchData.FromDate"
                type="datetime"
                format="jYYYY-jMM-jDD HH:mm:ss"
                display-format="jYYYY-jMM-jDD HH:mm:ss"
                class="date-picker"
                :label="$t('FromDate')"
                :clearable="true"
              />
            </div>
            <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
              <label class="vs-select--label datepicker-lb">{{
                $t("ToDate")
              }}</label>

              <date-picker
                v-model="gridSearchData.ToDate"
                type="datetime"
                format="jYYYY-jMM-jDD HH:mm:ss"
                display-format="jYYYY-jMM-jDD HH:mm:ss"
                class="date-picker"
                :label="$t('ToDate')"
                :clearable="true"
              />
            </div>
          </div>
          <div class="w-full">
            <div class="vx-row">
              <div class="vx-col lg:w-1/2 sm:w-1/1 w-full">
                <div class="w-full">
                  <vs-input
                    class="inputx"
                    v-model="gridSearchData.description"
                    @keyup.enter="submitFilter"
                    :label="$t('Description')"
                  />
                </div>
              </div>
              <div
                class="vx-col lg:w-1/4 flex gap-5 justify-end flex-1 sm:w-1/2 w-full pt-6"
              >
                <vs-button
                  type="filled"
                  class="float-right ml-0"
                  id="reset-btn"
                  @click.prevent="resetForm"
                  >{{ $t("ResetFilter") }}</vs-button
                >
                <vs-button
                  type="filled"
                  class="float-right"
                  @click.prevent="submitFilter"
                  :disabled="disabled"
                  >{{ $t("SubmitFilter") }}</vs-button
                >
              </div>
            </div>
          </div>
        </form>
        <div class="vx-row pt-4" v-if="filter">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('CreateOn'), sort: 'CreateOn' },
                { title: $t('StoreName'), sort: 'StoreName' },
                { title: $t('OperationType'), sort: 'OperationType' },
                { title: $t('Description'), sort: 'Description' },
                { title: $t('CheckInCheckOutNumber') },
                { title: $t('CheckInCount'), sort: 'CheckInCount' },
                { title: $t('CheckOutCount'), sort: 'CheckOutCount' },
                { title: $t('Balance'), sort: 'Balance' },
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 13%; direction: ltr">
                  {{ row.createOn.split(" ")[0] }}<br />{{
                    row.createOn.split(" ")[1]
                  }}
                </td>
                <td style="width: 23%">
                  {{ row.storeInfoDto.name ? row.storeInfoDto.name : "---" }}
                </td>
                <td style="width: 25%">
                  <span v-if="row.operation == 'CheckOut'">{{
                    $t("CheckOutTransaction")
                  }}</span>
                  <span v-if="row.operation == 'CheckIn'">{{
                    $t("CheckInTransaction")
                  }}</span>
                  <span v-if="row.operation == 'Transfer'">{{
                    $t("TransferTransaction")
                  }}</span>
                  <span v-if="row.operation == 'CheckInForReturnOrder'">{{
                    $t("CheckInForReturnOrder")
                  }}</span>
                  <span
                    v-if="row.operation == 'CheckOutForDischargePermission'"
                    >{{ $t("CheckOutForDischargePermission") }}</span
                  >
                  <span v-if="row.operation == 'CheckInWithExcelFile'">{{
                    $t("CheckInWithExcelFile")
                  }}</span>
                </td>
                <td style="width: 23%">
                  {{ row.description ? row.description : "---" }}
                </td>
                <td style="width: 12%">
                  <span
                    v-if="
                      row.operation == 'CheckIn' ||
                      row.operation == 'CheckInForReturnOrder' ||
                      row.operation == 'CheckInWithExcelFile'
                    "
                  >
                    <router-link
                      :to="{
                        path:
                          '/CheckInTransactions/Details/' + row.transactionId,
                      }"
                    >
                      <vs-button
                        color="primary"
                        type="border"
                        icon-pack="feather"
                        icon="icon-eye"
                        class="view-details"
                        v-has-permission="permission128"
                        >{{ row.transactionId }}</vs-button
                      >
                    </router-link>
                  </span>
                  <span
                    v-if="
                      row.operation == 'CheckOut' ||
                      row.operation == 'CheckOutForDischargePermission'
                    "
                  >
                    <router-link
                      :to="{
                        path:
                          '/CheckOutTransactions/Details/' + row.transactionId,
                      }"
                      target="_blank"
                    >
                      <vs-button
                        color="primary"
                        type="border"
                        icon-pack="feather"
                        icon="icon-eye"
                        class="view-details"
                        >{{ row.transactionId }}</vs-button
                      >
                    </router-link>
                  </span>
                  <span v-if="row.operation == 'Transfer'">
                    <router-link
                      :to="{
                        path:
                          '/TransferTransactions/Details/' + row.transactionId,
                      }"
                      target="_blank"
                    >
                      <vs-button
                        color="primary"
                        type="border"
                        icon-pack="feather"
                        icon="icon-eye"
                        class="view-details"
                        >{{ row.transactionId }}</vs-button
                      >
                    </router-link>
                  </span>
                </td>
                <td style="width: 10%">
                  {{ row.checkInCount }}
                </td>
                <td style="width: 10%">
                  {{ row.checkOutCount }}
                </td>
                <td style="width: 12%">
                  {{ row.balance }}
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
#reset-btn {
  margin-left: 1.5rem;
  background: #3ec9d6 !important;
}
.vs-select--label {
  display: block;
}
.view-details {
  padding: 0.1rem 0.75rem !important;
  display: inline-block;
  margin: 0.4rem 0 0.2rem 0;
}

.view-details i {
  padding-left: 0.2rem;
  position: relative;
  top: 2px;
  display: inline-block;
}
</style>
<script>
import { mapActions } from "vuex";
import "../../../assets/scss/vuesax-rtl/pages/_warehouse.scss";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import vSelect from "vue-select";
import { Validator } from "vee-validate";
import Treeselect from "@/components/CustomTreeSelect.vue";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import DataGrid from "@/components/datagrid/DataGrid";

const dict = {
  custom: {
    stockid: {
      required: "لطفا نام محصول را انتخاب نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  name: "warehouseManagement_Cardex_Index",
  components: {
    datePicker: VuePersianDatetimePicker,
    "v-select": vSelect,
    Treeselect,
    DataGrid,
  },
  data() {
    return {
      showFilters: true,
      permission128: "GetInventoryTransactionItemsByInventoryTransaction",
      stockId: null,
      fromDate: "",
      toDate: "",
      description: "",
      filter: false,
      disabled: false,
      gridDataSource: {
        type: "app",
        service: "Inventory/api/KardexQuery",
      },
      gridSearchData: {
        StockId: null,
        FromDate: "",
        ToDate: "",
        description: "",
      },
      searchQueryNew: "",
      searchQueryOld: "",
    };
  },
    // computed: {
    // ...mapGetters({
    // })},


  mounted() {
    this.fetchWarehouses();
  },
  methods: {
    ...mapActions({
      fetchSearch: "stock/fetchSearch",
      fetchWarehouses: "warehouse/fetchListWithNOTakeSkip",
    }),
    loadOptions({ action, searchQuery, callback }) {
      this.searchQueryNew = searchQuery;
      this.searchQueryOld = this.searchQueryNew;
      setTimeout(() => {
        this.searchQueryNew = searchQuery;
        if (this.searchQueryOld == this.searchQueryNew) {
          if (action === ASYNC_SEARCH) {
            this.fetchSearch(searchQuery).then((r) => {
              const options = [];
              r.forEach(function (element) {
                options.push({
                  id: element.stockId,
                  label: element.stockName,
                });
              });
              callback(null, options);
            });
          }
        }
      }, 2000);
    },
    onStockSelected(data) {
      this.searchstockId = data.id;
    },
    submitFilter() {
      if (
        this.gridSearchData.FromDate == this.gridSearchData.ToDate ||
        this.gridSearchData.FromDate < this.gridSearchData.ToDate ||
        (this.gridSearchData.FromDate != "" && this.gridSearchData.ToDate == "")
      ) {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.filter = true;
            setTimeout(() => {
              this.$refs.grid.renderGrid();
            }, 0);
            this.disabled = false;
          }
        });
      } else {
        this.$swal({
          position: "center-center",
          type: "error",
          text: "در انتخاب تاریخ ورودی و خروجی دقت نمایید!",
          showConfirmButton: false,
          timer: 8000,
        });
        this.disabled = false;
      }
    },
    resetForm() {
      this.$router.go(this.$router.currentRoute);
    },
  },
};
</script>
